import Phaser from 'phaser';
import { SCENE_KEYS, GAME_CONFIG } from '@/config/constants';
import { COLORS } from '@/ui/theme';
import { transitionTo, fadeIn } from '@/utils/UIAnimations';
import { MechanicsTutorialModal } from '@/ui/MechanicsTutorialModal';

/**
 * ControlsScene — standalone "1-2-3" controls overview.
 *
 * Reuses the SettingsScene background shell (video bg + gradient + glows +
 * vignette) and stamps the MechanicsTutorialModal on top so kiosk players
 * can review the joystick / A+B controls without restarting a run. Modal
 * dismiss (LET'S PLAY, B button, ESC) returns to the menu.
 */
export class ControlsScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENE_KEYS.CONTROLS });
  }

  create(): void {
    const { WIDTH, HEIGHT } = GAME_CONFIG;
    const cx = WIDTH / 2;
    const cy = HEIGHT / 2;
    fadeIn(this, 400);

    const videoKey = 'bg_video_world1_video';
    if (this.cache.video.has(videoKey)) {
      const videoBg = this.add.video(cx, cy, videoKey);
      videoBg.setDepth(0).setScale(1).setVolume(0).play(true).setAlpha(0.64);
    }

    const bg = this.add.graphics().setDepth(1);
    bg.fillGradientStyle(COLORS.midnightDepth, COLORS.midnightDepth, COLORS.deepOcean, COLORS.deepOcean, 0.9, 0.9, 0.98, 0.98);
    bg.fillRect(0, 0, WIDTH, HEIGHT);

    const glows = this.add.graphics().setDepth(2);
    glows.fillStyle(COLORS.aqua, 0.1);
    glows.fillCircle(cx, cy - 160, 260);
    glows.fillStyle(COLORS.sapphire, 0.14);
    glows.fillCircle(cx - 380, cy + 60, 220);
    glows.fillCircle(cx + 380, cy + 80, 220);

    const vignette = this.add.graphics().setDepth(3);
    vignette.fillGradientStyle(0x000000, 0x000000, 0x000000, 0x000000, 0.78, 0.78, 0, 0).fillRect(0, 0, WIDTH, 150);
    vignette.fillGradientStyle(0x000000, 0x000000, 0x000000, 0x000000, 0, 0, 0.82, 0.82).fillRect(0, HEIGHT - 150, WIDTH, 150);

    const modal = new MechanicsTutorialModal(this, () => {
      transitionTo(this, SCENE_KEYS.MENU);
    }, { ctaLabel: 'OK' });
    modal.show();

    this.input.keyboard?.on('keydown-ESC', () => transitionTo(this, SCENE_KEYS.MENU));
  }
}
